<template>
  <div>
    <b-table
      bordered
      small
      :fields="fields"
      :items="parameters"
      fixed
    >
      <template #cell(name)="data">
        <code class="bid-parameter__name">{{ data.item.name }}</code>
      </template>
      <!-- eslint-disable vue/no-v-html -->
      <template #cell(description)="data">
        <div v-html="data.item.description" />
      </template>
      <!-- eslint-enable -->
      <template #cell(choices)="data">
        <span
          v-for="(choice, idx) in data.item.choices"
          :key="choice"
        >
          <code>{{ choice }}</code>
          <span
            v-if="idx !== data.item.choices.length - 1"
            class="ml-1 mr-1"
          >|</span>
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'SellerOfferBidParameters',

  props: {
    /**
     * @type {import('vue').PropType<Seller.OfferBidParameters>}
     */
    parameters: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      fields: [
        { key: 'name', thClass: 'fixed-width-130' },
        { key:'description', tdClass: 'w-50' },        
        {
          key: 'choices',
          label: 'Valid Values'
        }
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
// One line with a mouse. The name column is 130px wide and the table's layout fixed, so a long name
// such as publisherInboundCallId (about 170px) ran over the description beside it. On a touch screen
// it wraps inside its column instead.
.bid-parameter__name {
  white-space: nowrap;
}

@include touch-screen {
  .bid-parameter__name {
    white-space: normal;
    overflow-wrap: anywhere;
  }
}
</style>